import script from "./image.vue?vue&type=script&setup=props&lang=js"
export * from "./image.vue?vue&type=script&setup=props&lang=js"

const __exports__ = script;

export default __exports__